import customer from '../../assets/customer.png'
import './styless.scss'
import React, {useState, useRef, useEffect} from 'react'
import {CustomerIcon, DocumentIcon, NoticeIcon} from "../../icons";
import {Dialog, DialogContent} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {getAnnouncements, getAnnouncementsById} from "../../api/common";
import {NoticeProps} from "../../types/common.types";
import ReactMarkdown from 'react-markdown'
import {getLocalStorage, setLocalStorage} from "../../util/storage";
import {useSelector} from "react-redux";
import {RootState} from "../../store";
import {useMatomoTrackingPoint} from "../../hooks/useMatomoTrackingPoint";

export default function CustomerService() {
    const {trackSupportPopupShow, trackContactSupportClick, trackOfficialNoticeClick, trackUserGuideClick} = useMatomoTrackingPoint();
    const [showOptions, setShowOptions] = useState(false)
    const [showNotice, setShowNotice] = useState(false)
    const [noticeDetail, setNoticeDetail] = useState<NoticeProps | null>(null)
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)
    const memberInfo = useSelector((state: RootState) => state.member.memberInfo);

    const handleMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current)
            timeoutRef.current = null
        }
        setShowOptions(true)
    }

    useEffect(() => { // 客服头像弹窗展示埋点
        if (showOptions) {
            trackSupportPopupShow({page_id: window.location.href});
        }
    }, [showOptions, trackSupportPopupShow]);

    const handleMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            setShowOptions(false)
            timeoutRef.current = null
        }, 1000)
    }

    useEffect(() => {
        getAnnouncements().then(res => {
            if (res && res.length) {
                setNoticeDetail(res[0])
                if (!res[0].isRead && memberInfo && (Date.now() - memberInfo.createAt > 5 * 60 * 1000)) setShowNotice(true)
            }else {
                setNoticeDetail(null)
            }
        })
    }, [memberInfo]);

    useEffect(() => { // 触发已读
        if (showNotice && noticeDetail && !noticeDetail.isRead) {
            getAnnouncementsById(noticeDetail.id).then(res => {})
        }
    }, [showNotice, noticeDetail]);

    return (
        <>
            <Dialog
                open={showNotice}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: 'none',
                        borderRadius: "20px"
                    },
                    '& .MuiDialogContent-root': {
                        padding: '0',
                    }
                }}
            >
                <DialogContent>
                    <div className='noticeDetail'>
                        <div className='noticeTitle'>
                            <div><ReactMarkdown>{noticeDetail?.title}</ReactMarkdown></div>
                            <CloseIcon onClick={()=>{setShowNotice(false)}}/>
                        </div>
                        <div className='noticeContent'>
                            <ReactMarkdown>
                                {noticeDetail?.description || ''}
                            </ReactMarkdown>
                        </div>
                    </div>
                </DialogContent>
            </Dialog>
            <div className='customer-container' onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <img src={customer} width={80} alt='' draggable={false}/>
                {showOptions && (
                    <div className='options-block'>
                        <div onClick={() => {
                            trackContactSupportClick({page_id: window.location.href});
                            window.open('https://qm.qq.com/q/DdeNxVg01i', '_blank')
                        }}><CustomerIcon/>&nbsp;&nbsp;联系客服</div>
                        <div onClick={() => {
                            trackOfficialNoticeClick({page_id: window.location.href});
                            setShowNotice(true)
                        }}><NoticeIcon/>&nbsp;&nbsp;官方公告</div>
                        <div onClick={() => {
                            trackUserGuideClick({page_id: window.location.href});
                            window.open('https://docs.qq.com/doc/DVXJDRXpxbGhMa25V', '_blank')
                        }}><DocumentIcon/>&nbsp;&nbsp;教程文档</div>
                    </div>
                )}
            </div>
        </>
    )
}